import { Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export function NotFound() {
  const navigate = useNavigate();

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center py-5 px-3"
      style={{ minHeight: "60vh" }}
    >
      <Card
        className="border-0 rounded-3 shadow"
        style={{ maxWidth: "420px", width: "100%" }}
      >
        <Card.Body className="p-4">
          <h1
            className="fw-bold mb-2 select-none"
            style={{ fontSize: "4.5rem", color: "#4d072c", lineHeight: 1 }}
          >
            404
          </h1>

          <h4 className="text-center fw-medium text-dark mb-2">
            Page Not Found
          </h4>

          <p className="text-muted mb-4 mx-auto" style={{ fontSize: "14px" }}>
            The page or route you requested does not exist or has been relocated
            within your CRM workspace.
          </p>

          <div className="d-grid gap-2">
            <Button
              variant="btn btn-default"
              size="sm"
              onClick={() => navigate("/dashboard")}
            >
              Return to Dashboard
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
